import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getJobs({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_JOBS_REQUEST')

        return axios
            .get(`/prepress-reports/prepress-jobs${paginate}${query}`)
            .then(response => {
                commit('GET_JOBS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_JOBS_FAILURE')
                handleApiError(error, 'Pobranie listy zleceń nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getJobPlates({ commit }, {
        query = ''
    } = {}) {
        commit('GET_JOB_PLATES_REQUEST')

        return axios
            .get(`/prepress-reports/prepress-job-plates${query}`)
            .then(response => {
                commit('GET_JOB_PLATES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_JOB_PLATES_FAILURE')
                handleApiError(error, 'Pobranie montaży nie powiodło się.')

                return Promise.reject(error)
            })
    },
    reportJobPlate({ commit }, payload) {
        return axios
            .post(`/prepress-reports/report-plate/${payload.plateId}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zlecenie zostało zaraportowane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zaraportowanie zlecenia nie powiódło się.')

                return Promise.reject(error)
            })
    },
    getAggregatedJobs({ commit }) {
        return axios
            .get('/prepress-reports/prepress-jobs-aggregated')
            .then(response => {
                commit('GET_AGGREGATED_JOBS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie maszyn z zadaniami nie powiodło się.')

                return Promise.reject(error)
            })
    },
    clearJobPlates({ commit }) {
        commit('CLEAR_JOBS_PLATES')
    },
    setJobsFilters({ commit }, filters) {
        commit('SET_JOBS_FILTERS', filters)
    },
    clearJobsFilters({ commit }) {
        commit('CLEAR_JOBS_FILTERS')
    }
}